import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const girlIcon: SvgIconData = {
  viewBox: '16.8 5 66.4 90',
  element: (
    <path d="M83.2 38.2C83.2 19.9 68.4 5 50 5S16.8 19.9 16.8 38.2C16.8 54.8 29 68.6 44.9 71v4.4h-9.2v10.3h9.2V95h10.3v-9.2h9.2V75.5h-9.2v-4.4c15.9-2.5 28-16.3 28-32.9m-56.1 0c0-12.6 10.3-22.9 22.9-22.9s22.9 10.3 22.9 22.9-10.3 23-22.9 23-22.9-10.3-22.9-23" />
  ),
};
